exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.main {\n    margin: 1ex;\n    padding: 1ex;\n    border: thick double #222;\n  }\n  \n  div.button {\n    text-align: right;\n    margin: 0.6ex;\n  }\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/crossref-box/crossref-box.component.css
// module id = ../../../../../src/app/crossref-box/crossref-box.component.css
// module chunks = main